module.exports = __webpack_public_path__ + "img/check-circle.605c5d6b.svg";